var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserActionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4406_71213)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 29,
    height: 29,
    rx: 5,
    fill: "#718EBF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 13C20 14.6569 18.6569 16 17 16C15.3431 16 14 14.6569 14 13C14 11.3431 15.3431 10 17 10C18.6569 10 20 11.3431 20 13ZM17 15C18.1046 15 19 14.1046 19 13C19 11.8954 18.1046 11 17 11C15.8954 11 15 11.8954 15 13C15 14.1046 15.8954 15 17 15Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2561 22C17.1431 21.6805 17.0653 21.3445 17.0271 20.9965H12C12.0014 20.7497 12.1538 20.0104 12.8321 19.3321C13.4844 18.6798 14.7109 18 17 18C17.2605 18 17.5072 18.0088 17.7409 18.0254C17.9661 17.684 18.2365 17.3752 18.5436 17.1073C18.0771 17.0382 17.564 17 17 17C12 17 11 20 11 21C11 22 12 22 12 22H17.2561Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 20.5C25 22.433 23.433 24 21.5 24C19.567 24 18 22.433 18 20.5C18 18.567 19.567 17 21.5 17C23.433 17 25 18.567 25 20.5ZM21.5 18.5C21.2239 18.5 21 18.7239 21 19V20.5C21 20.7761 21.2239 21 21.5 21C21.7761 21 22 20.7761 22 20.5V19C22 18.7239 21.7761 18.5 21.5 18.5ZM21.5 22.5C21.7761 22.5 22 22.2761 22 22C22 21.7239 21.7761 21.5 21.5 21.5C21.2239 21.5 21 21.7239 21 22C21 22.2761 21.2239 22.5 21.5 22.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4406_71213",
    x: 0,
    y: 0,
    width: 37,
    height: 37,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4406_71213"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4406_71213",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserActionIcon);
export default __webpack_public_path__ + "static/media/user-action-icon.0a877e2c3818d16700eb7517dd08624f.svg";
export { ForwardRef as ReactComponent };